import { ChainId } from 'constants/chains'
import { constructSameAddressMap } from '../utils/constructSameAddressMap'
import { MAINNET, TESTNET } from './periphery'

// Actively Deployed by us

export const V2_FACTORY_ADDRESS = {
  // Unit Tests
  [ChainId.MAINNET]: '0x2c97D1fd450105cc69E05a4127E425bf4b826264',
  [ChainId.TESTNET]: TESTNET.factory,
  [ChainId.HOMESTEAD]: '0x1F98431c8aD98523631AE4a59f267346ea31F984',
}
export const MULTICALL2_ADDRESSES = {
  [ChainId.MAINNET]: MAINNET.multicall2,
  [ChainId.TESTNET]: TESTNET.multicall2,
  [ChainId.HOMESTEAD]: '0x5BA1e12693Dc8F9c48aAD8770482f4739bEeD696',
}

export const V2_ROUTER_ADDRESS = {
  [ChainId.MAINNET]: '0x649795E53A9b69CB76A71f1ad1038039F9c65Ab5',
  [ChainId.TESTNET]: TESTNET.router,
  [ChainId.HOMESTEAD]: '0x68b3465833fb72A70ecDF485E0e4C7bD8665Fc45',
}

export const MINICHEF_V2_ADDRESS = {
  [ChainId.MAINNET]: MAINNET.minichef,
  [ChainId.TESTNET]: TESTNET.miniChef,
  [ChainId.HOMESTEAD]: '0x366eF26c172785DD402492c8290B2FB53E16d2C3',
}

export const AIRDROP_ADDRESS = {
  [ChainId.MAINNET]: MAINNET.airdrop,
  [ChainId.TESTNET]: TESTNET.airdrop,
  [ChainId.HOMESTEAD]: '',
}

export const EXZOSWAPTOKEN_BAR_ADDRESS = {
  [ChainId.MAINNET]: MAINNET.diffusionbar,
  [ChainId.TESTNET]: TESTNET.diffusionbar,
  [ChainId.HOMESTEAD]: '0x9AC19677BD6B1a3ba046C33f4D2f1952cA0e9a13',
}

// Used but ultimately not ours
export const WETH9_ADDRESS = {
  [ChainId.MAINNET]: '0xf492ddcF9432117b99375c0bD030eaBbdc495ae9',
  [ChainId.TESTNET]: TESTNET.weth9,
  [ChainId.HOMESTEAD]: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
}

/**
 * ------------------------------------------------------------------------------------
 * Not sure if these are used in the diffusion codebase
 * @TODO: cleanup
 */

export const GOVERNANCE_ADDRESS = constructSameAddressMap('0x5e4be8Bc9637f0EAA1A755019e06A68ce081D58F')
export const TIMELOCK_ADDRESS = constructSameAddressMap('0x1a9C8182C09F50C8318d769245beA52c32BE35BC')
export const MERKLE_DISTRIBUTOR_ADDRESS: { [chainId in ChainId]?: string } = {
  [ChainId.MAINNET]: '0x090D4613473dEE047c3f2706764f49E0821D256e',
}
export const ARGENT_WALLET_DETECTOR_ADDRESS: { [chainId in ChainId]?: string } = {
  [ChainId.MAINNET]: '0xeca4B0bDBf7c55E9b7925919d03CbF8Dc82537E8',
}
export const V3_CORE_FACTORY_ADDRESSES = constructSameAddressMap('@TODO:CHANGEME1234567890')
export const QUOTER_ADDRESSES = constructSameAddressMap('0xb27308f9F90D607463bb33eA1BeBb41C27CE5AB6')
export const NONFUNGIBLE_POSITION_MANAGER_ADDRESSES = constructSameAddressMap(
  '0xC36442b4a4522E871399CD717aBDD847Ab11FE88'
)
export const ENS_REGISTRAR_ADDRESSES = {
  [ChainId.MAINNET]: '0xae9Da235A2276CAa3f6484ad8F0EFbF4e0d45246',
  [ChainId.TESTNET]: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
}
export const SOCKS_CONTROLLER_ADDRESSES = {
  [ChainId.MAINNET]: '0x65770b5283117639760beA3F867b69b3697a91dd',
}
export const SWAP_ROUTER_ADDRESSES = constructSameAddressMap('0xE592427A0AEce92De3Edee1F18E0157C05861564')
export const V3_MIGRATOR_ADDRESSES = constructSameAddressMap('0xA5644E29708357803b5A882D272c41cC0dF92B34')
